<template>
  <div>
    <div class="pt-6">
      <!-- <div class="py-6 text-center" v-show="!isLoaded">
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div> -->
      <div class="relative">
        <div class="bg-white shadow">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
            <div v-if="!isLoaded"
              class="absolute inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50">
              <div class="loader"></div>
              <p class="text-gray-700 text-lg">Loading...</p>
            </div>
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t("messages.player.playerLogin.action") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.player.playerLogin.ip") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.player.playerLogin.success") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.player.playerLogin.date") }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="data in dataRows" :key="data.id" class="hover:bg-gray-50">
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data.action }}
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ data.ip }}
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    <span v-if="data.isSuccess == true"
                      class="bg-green-600 inline-block px-2 py-1 rounded-lg text-white text-xs">
                      <font-awesome-icon class="mr-1" :icon="['far', 'check']" transform="" />
                      สำเร็จ
                    </span>
                    <span v-if="data.isSuccess == false"
                      class="bg-red-600 inline-block px-2 py-1 rounded-lg text-white text-xs">
                      <font-awesome-icon class="mr-1" :icon="['far', 'xmark']" transform="" />
                      ไม่สำเร็จ
                    </span>
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ dayjs(data.createdAt).format("LLL") }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
              <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                  <p class="text-sm text-gray-700">
                    <Listbox as="div" v-model="rowsPerPage">
                      <ListboxButton
                        class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        <span class="block truncate">{{
                          rowsPerPage.value
                          }}</span>
                        <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                          <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </span>
                      </ListboxButton>
                      <ListboxOptions
                        class="absolute z-10 mt-1 w-44 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                        <ListboxOption as="template" v-for="(option, index) in rowsPerPageOption" :key="index"
                          :value="option" @click="refetch()">
                          <li :class="[
                              'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                            ]">
                            <span>
                              {{ option.label }}
                            </span>
                          </li>
                        </ListboxOption>
                      </ListboxOptions>
                    </Listbox>
                    Showing
                    {{ " " }}
                    <span class="font-medium">{{ offset + 1 }}</span>
                    {{ " " }}
                    to
                    {{ " " }}
                    <span class="font-medium">{{
                      offset + dataRows.length
                      }}</span>
                    {{ " " }}
                    of
                    {{ " " }}
                    <span class="font-medium">{{ dataCount }}</span>
                    {{ " " }}
                    results
                  </p>
                </div>
                <div>
                  <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                    <a href="javascript:void(0)" @click="jump(1)"
                      class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                      <span class="sr-only">First</span>
                      <span class="h-5 w-5 text-center">
                        <font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-double-left']"
                          transform="shrink-2" />
                      </span>
                    </a>
                    <a href="javascript:void(0)" @click="prev"
                      class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                      <span class="sr-only">Previous</span>
                      <span class="h-5 w-5 text-center">
                        <font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-left']" transform="shrink-2" />
                      </span>
                    </a>
                    <a href="javascript:void(0)" @click="jump(paginationOffset(i))" v-for="i in pageCount()" :key="i"
                      :class="
                        currentPage === i
                          ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                          : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                      " :style="{
                        display:
                          Math.abs(i - currentPage) < 2 || i == 0
                            ? 'block'
                            : 'none',
                      }">
                      {{ i }}
                    </a>
                    <a href="javascript:void(0)" @click="next"
                      class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                      <span class="sr-only">Next</span>
                      <span class="h-5 w-5 text-center">
                        <font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-right']"
                          transform="shrink-2" />
                      </span>
                    </a>
                    <a href="javascript:void(0)" @click="jump(Math.ceil(dataCount / rowsPerPage.value))"
                      class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                      <span class="sr-only">Last</span>
                      <span class="h-5 w-5 text-center">
                        <font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-double-right']"
                          transform="shrink-2" />
                      </span>
                    </a>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";

dayjs.extend(localizedFormat);

const pages = [
  { name: "Players", href: { name: "Player List" }, current: false },
];
const rowsPerPageOption = [{ label: "100", value: 100 }];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    SelectorIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
  },
  setup() {
    const offset = ref(0);
    const rowsPerPage = ref({ label: "100", value: 100 });
    const currentPage = ref(1);
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);

    onMounted(() => {
      refetch();
    });

    const refetch = () => {
      isLoaded.value = false;
      route.query.page ? (currentPage.value = parseInt(route.query.page)) : 1;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/operator-admin/login-history/pagination",
          {
            operatorId: store.state.selectedOperator.operatorId,
            userId: route.params.id,
            limit: rowsPerPage.value.value,
            offset: parseInt(route.query.page) - 1 || currentPage.value - 1,
          }
        )
        .then(({ data }) => {
          dataRows.value = data.result;
          dataCount.value = data.result.length;
          isLoaded.value = true;
        })
        .catch(({ response }) => {
          console.log(response.data);
        });
    };

    const prev = () => {
      if (currentPage.value - 1 >= 1) {
        currentPage.value -= 1;
        offset.value = (currentPage.value - 1) * rowsPerPage.value.value;
        router.push({ query: { page: currentPage.value } });
        route.query.page = currentPage.value;
        refetch();
      }
    };

    const next = () => {
      if (currentPage.value + 1 <= pageCount()) {
        currentPage.value += 1;
        offset.value = rowsPerPage.value.value * currentPage.value;
        router.push({ query: { page: currentPage.value } });
        route.query.page = currentPage.value;
        refetch();
      }
    };

    const pageCount = (i) => {
      return Math.ceil(dataCount.value / rowsPerPage.value.value);
    };

    const paginationOffset = (i) => {
      return (parseInt(route.query.page) || 1) < 4
        ? i
        : parseInt(route.query.page) > Math.floor(dataCount.value / 10) - 3
        ? Math.floor(dataCount.value / 10) - 6 + i
        : route.query.page - 4 + i;
    };

    const jump = (page) => {
      currentPage.value = page;
      offset.value = (page - 1) * rowsPerPage.value.value;
      router.push({ query: { page: currentPage.value } });
      route.query.page = currentPage.value;
      refetch();
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    return {
      dataRows,
      dataCount,
      isLoaded,
      route,
      dayjs,
      pageCount,
      paginationOffset,
      jump,
      viewData,
      prev,
      next,
      pages,
      refetch,
      currentPage,
      offset,
      rowsPerPageOption,
      rowsPerPage,
    };
  },
};
</script>
<style scoped>
/* Add a simple spinner style without a background color */
.loader {
  border: 4px solid rgba(0, 0, 0, 0.1); 
  border-radius: 50%;
  border-top: 4px solid transparent; 
  width: 36px;
  height: 36px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>